import axios from "axios";
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`;

const couponCodeValidation = async (code) => {
  const { data } = await axios.get(
    `${baseUrl}/promotion/couponMaster/codeValidation?code=${code}`,
  );
  return data;
};

const readCouponById = async (id) => {
  const { data } = await axios.get(
    `${baseUrl}/promotion/couponMaster/coupon?id=${id}`,
  );
  return data;
};

const readCouponList = async (
  offset,
  pageSize,
  coupon_id,
  coupon_title,
  orderType,
  orderBy,
  userId,
) => {
  const { data } = await axios.get(
    `${baseUrl}/promotion/couponMaster/couponList?offset=${offset}&pageSize=${pageSize}&couponId=${coupon_id}&couponTitle=${coupon_title}&orderType=${orderType}&orderBy=${orderBy}&userId=${userId}`,
  );
  return data;
};

const createCoupon = async (coupon) => {
  const { data } = await axios.post(
    `${baseUrl}/promotion/couponMaster/create`,
    coupon,
  );
  return data;
};

const editCoupon = async (coupon) => {
  const { data } = await axios.post(
    `${baseUrl}/promotion/couponMaster/edit`,
    coupon,
  );
  return data;
};

const userCouponChangeStatus = async (coupon) => {
  const { data } = await axios.post(
    `${baseUrl}/userCouponCart/changeAvailable`,
    coupon,
  );
  return data;
};

const readContentById = async (id) => {
  const { data } = await axios.get(`${baseUrl}/content/admin/one?id=${id}`);
  return data;
};

const readContentTopBanner = async () => {
  const { data } = await axios.get(`${baseUrl}/content/topBanner`);
  return data;
};

const readContentList = async (param) => {
  const { data } = await axios.get(`${baseUrl}/content/admin/list`, {
    params: param,
  });
  return data;
};

const createContent = async (param) => {
  const { data } = await axios.post(`${baseUrl}/content/create`, param);
  return data;
};

const editContent = async (param) => {
  const { data } = await axios.post(`${baseUrl}/content/edit`, param);
  return data;
};

const deleteContent = async (param) => {
  const { data } = await axios.delete(`${baseUrl}/content/delete`, {
    params: param,
  });
  return data;
};

const promotionApi = {
  couponCodeValidation,
  readCouponById,
  readCouponList,
  createCoupon,
  editCoupon,
  userCouponChangeStatus,
  readContentById,
  readContentTopBanner,
  readContentList,
  createContent,
  editContent,
  deleteContent,
};

export default promotionApi;
